import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { getHeaders } from "./headers"
import DataTable from "ui/DataTable"
import CustomPagination from "components/common/CustomPagination"

const WaiversTable = ({ data, pageSize, onPageChange, onPageSizeChange, onSortChange, metadata, onRowClick, sortKey, sortOrder }) => {
  const { t } = useTranslation()

  return (
    <>
      <DataTable
        columns={getHeaders(sortKey, sortOrder, onRowClick, t)}
        dataSource={data}
        rowKey={(_, index) => index}
        onRow={(record) => ({ onClick: () => onRowClick(record) })}
        rowClassName={() => "cursor-pointer"}
        pagination={false}
        onChange={onSortChange}
      />
      <CustomPagination
        metadata={metadata}
        pageSize={pageSize}
        total={metadata?.total_results || 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </>
  )
}

WaiversTable.propTypes = {
  data: PropTypes.array,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSortChange: PropTypes.func,
  metadata: PropTypes.object,
  onRowClick: PropTypes.func,
  sortKey: PropTypes.string,
  sortOrder: PropTypes.string
}

export default WaiversTable
